module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7695b6f141042be8657724e077c1412b.png";